<template>
    <div class="max-content">
        <div class="content-wrapper" v-if="getUser.userType === '1'">
            <ul style="list-style: decimal; padding: 0 20px">
                <li v-html="$t('kcc_max_speed_kp_tip1')" />
                <li v-html="$t('kcc_max_speed_kp_tip2')" />
                <li v-html="$t('kcc_max_speed_kp_tip3')" />
                <li v-html="$t('kcc_max_speed_kp_tip4')" />
                <li v-html="$t('kcc_max_speed_kp_tip5')" />
                <li v-if="$i18n.locale == 'en'">
                    For large groups with thousands of PBC line items, consider setting up multiple KCC sites (contact
                    <span style="color: #1e49e2; text-decoration: underline" @click="openEmail">KCC Team</span> to seek support)
                </li>
                <li v-else>
                    对于拥有数千条PBC需求条目的大型集团项目，请考虑创建多个KCC站点进行管理（请联系<span
                        style="color: #1e49e2; text-decoration: underline"
                        @click="openEmail"
                        >KCC团队</span
                    >获取帮助）
                </li>
                <li>
                    {{ $t('kcc_max_speed_kp_tip7') }}
                    <ul style="list-style: disc; padding: 0 20px">
                        <li v-html="$t('kcc_max_speed_kp_tip7_1')" />
                        <li v-html="$t('kcc_max_speed_kp_tip7_2')" />
                        <li v-html="$t('kcc_max_speed_kp_tip7_3')" />
                    </ul>
                </li>
            </ul>
        </div>
        <div class="content-wrapper" v-else>
            <ul style="list-style: decimal; padding: 0 20px">
                <li v-html="$t('kcc_max_speed_client_tip1')" />
                <li v-html="$t('kcc_max_speed_client_tip2')" />
                <li v-html="$t('kcc_max_speed_client_tip3')" />
                <li v-html="$t('kcc_max_speed_client_tip4')" />
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import windowConfig from '@/utils/windowConfig'

export default {
    name: 'maximise-speed',
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser'
        })
    },
    methods: {
        openEmail() {
            window.open(windowConfig.helpURL['Contact'], '_blank')
        }
    }
}
</script>

<style scoped>
.max-content {
    margin-bottom: 4px;
    font-size: 15px;
    line-height: 20px;
    color: rgba(94, 94, 94, 0.8);
}

.content-wrapper {
    background-color: #fff;
    border-radius: 5px;
    color: #333333;
}
.highLight {
    color: #1e49e2;
}
</style>
